module.exports = __webpack_public_path__ + "img/man-2.c07027fb.svg";